module.exports = __webpack_public_path__ + "static/img/2_4_1.8d5c4e4d.jpg";